"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TSBlockType = exports.TSColors = void 0;
var TSColors;
(function (TSColors) {
    TSColors[TSColors["Red"] = 16711680] = "Red";
    TSColors[TSColors["Green"] = 65280] = "Green";
    TSColors[TSColors["Blue"] = 255] = "Blue";
    TSColors[TSColors["Yellow"] = 16776960] = "Yellow";
    TSColors[TSColors["Teal"] = 32896] = "Teal";
    TSColors[TSColors["Purple"] = 8388736] = "Purple";
    TSColors[TSColors["Gray"] = 8947848] = "Gray";
    TSColors[TSColors["LightGray"] = 13421772] = "LightGray";
    TSColors[TSColors["DarkGray"] = 4473924] = "DarkGray";
})(TSColors = exports.TSColors || (exports.TSColors = {}));
class TSBlockType {
    constructor(color, char) {
        this.char = char;
        this.color = color;
    }
}
exports.TSBlockType = TSBlockType;
TSBlockType.Red = new TSBlockType(0xFF0000, 'R');
TSBlockType.Green = new TSBlockType(0x00FF00, 'G');
TSBlockType.Blue = new TSBlockType(0x0000FF, 'B');
TSBlockType.Yellow = new TSBlockType(0xFFFF00, 'Y');
TSBlockType.Teal = new TSBlockType(0x008080, 'T');
TSBlockType.Purple = new TSBlockType(0x800080, 'P');
TSBlockType.Gray = new TSBlockType(0x888888, 'x');
TSBlockType.LightGray = new TSBlockType(0xCCCCCC, 'x');
TSBlockType.DarkGray = new TSBlockType(0x444444, 'X');
TSBlockType.White = new TSBlockType(0xFFFFFF, 'W');
TSBlockType.Brown = new TSBlockType(0xA52A2A, '=');
TSBlockType.SkyBlue = new TSBlockType(0x87CEEB, 'b');
